import { BlockWithAlignableContents } from '@lexical/react/LexicalBlockWithAlignableContents';
import {
  Box,
  Button,
  Typography,
} from '@mui/material';
import { ElementFormatType, NodeKey } from 'lexical';
import { useTranslation } from 'react-i18next';
import CommitmentSection from './Sections/CommitmentSection';
import ContractSection from './Sections/ContractSection';
import Results from './Results';
import PriceSection from './Sections/PriceSection';
import StyledBox from './styles';
import SerieFreePriceContextProvider from '../Contexts/SerieFreePriceContext/SerieFreePriceContextProvider';
import FreeResiliationFormulaContextProvider from '../Contexts/FreeResiliationFormulaContext/FreeResiliationFormulaContextProvider';
import useFreeResiliationFormulaContext from '../Contexts/FreeResiliationFormulaContext/useFreeResiliationFormulaContext';
import NewOfferForm from './Sections/NewOfferForm';

type FormulaNodeComponentProps = Readonly<{
  className: Readonly<{
    base: string;
    focus: string;
  }>;
  format: ElementFormatType | null;
  nodeKey: NodeKey;
}>;

function InnerFormulaNodeComponent(props: FormulaNodeComponentProps) {
  const {
    className, format, nodeKey,
  } = props;
  const { t } = useTranslation('wysiwyg');
  const { t: tCommon } = useTranslation('common');
  const { clear } = useFreeResiliationFormulaContext();
  return (
    <BlockWithAlignableContents
      className={className}
      format={format}
      nodeKey={nodeKey}
    >
      <StyledBox>
        <Box className="header">
          <Typography variant="subtitle1">
            {t('resiliation-fee.title')}
          </Typography>
          <Button onClick={() => clear()} variant="outlined" color="info">
            {tCommon('clear')}
          </Button>
        </Box>
        <Box>
          <Box className="fields">
            <ContractSection />
            <CommitmentSection />
            <PriceSection />
            <SerieFreePriceContextProvider>
              <NewOfferForm />
            </SerieFreePriceContextProvider>
          </Box>
          <Results />
        </Box>
      </StyledBox>
    </BlockWithAlignableContents>
  );
}

export default function FormulaNodeComponent(props: FormulaNodeComponentProps) {
  return <FreeResiliationFormulaContextProvider><InnerFormulaNodeComponent {...props} /></FreeResiliationFormulaContextProvider>;
}
